import { useEffect, useState } from "react";

/**
 * The consent UI lives in /consent.js (client/public/consent.js).
 *
 * The React component that used to live here drew its own overlay but gated
 * nothing: Google Analytics and the AdSense tag still loaded from the page head
 * regardless of what the visitor clicked, so the banner was decoration on top
 * of an active PECR breach. Consent is now enforced by Consent Mode v2 in the
 * head plus the /consent.js banner; this file only exposes the "change your
 * choice" control the footer needs.
 */

declare global {
  interface Window {
    tysConsent?: { show: () => void; read: () => unknown };
  }
}

export const COOKIE_POLICY_PATH = "/cookie-policy";
export const CONSENT_STORAGE_KEY = "tys-consent-v1";

export function CookieSettingsButton() {
  const [decided, setDecided] = useState(false);

  useEffect(() => {
    try {
      setDecided(!!localStorage.getItem(CONSENT_STORAGE_KEY));
    } catch {
      setDecided(false);
    }
  }, []);

  if (!decided) return null;

  return (
    <button
      type="button"
      className="underline underline-offset-2 hover:opacity-80"
      data-testid="cookie-settings"
      onClick={() => {
        if (window.tysConsent) window.tysConsent.show();
      }}
    >
      Cookie settings
    </button>
  );
}
